import { createSlice } from '@reduxjs/toolkit'

const initialState = {}

const userSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    setUsers(state, { payload }) {
      Object.entries(payload).forEach(([id, userData]) => {
        state[id] = { ...state[id], ...userData }
      })
    },
  },
})

export const { setUsers } = userSlice.actions
export default userSlice.reducer
